import React from 'react';
import { Field } from 'redux-form';
import { useIntl } from 'react-intl';
import { getName, doesValueMatchPersonData } from 'common/personUtils';
import { renderTokenLabel } from 'views/components/Search/PatientSearchUtils';
import { getMRNFromTag } from 'state/services/searchApiUtils';
import InputTagsSuggest from 'views/containers/InputTagsSuggest';

const renderPatientTag = (props, tokenPrefix, tokenSuffix) => {
  const {
    tag,
    key,
    disabled,
    onRemove,
    classNameRemove,
    getTagDisplayValue,
    ...other
  } = props;
  const displayValue = getTagDisplayValue(tag);
  const tokenLabel = renderTokenLabel(displayValue, tokenPrefix, tokenSuffix);
  return (
    <span key={key} {...other}>
      {tokenLabel !== null ? (
        tokenLabel
      ) : (
        <React.Fragment>{displayValue}</React.Fragment>
      )}
      {!disabled && (
        // eslint-disable-next-line jsx-a11y/anchor-has-content,jsx-a11y/anchor-is-valid
        <a className={classNameRemove} onClick={() => onRemove(key)} />
      )}
    </span>
  );
};

const PatientSearchField = ({
  placeholder,
  className,
  autocompleteData,
  styles = {},
  defaultValue = '',
  tokenPrefix = '',
  tokenSuffix = '',
  onRemoveTag = undefined,
}) => {
  const intl = useIntl();
  return (
    <div className={className || styles.searchTypeFields}>
      <Field
        name="patients"
        component={InputTagsSuggest}
        placeholder={
          placeholder ||
          intl.formatMessage({
            id: 'search.SearchForm.PatientField.PlaceHolder',
          })
        }
        suggestions={autocompleteData}
        getSuggestionValue={d => {
          let suggestValue = getName(d.firstName, d.lastName, '');
          if (d.customParticipantID) {
            suggestValue = `${suggestValue} [${tokenPrefix}${d.customParticipantID}${tokenSuffix}]`;
          }
          return suggestValue;
        }}
        renderSuggestion={d => (
          <div className={styles.autoSuggestSelectOption}>
            <p className={styles.autoSuggestSelectOptionPrimary}>
              {getName(d.firstName, d.lastName, '')}
            </p>
            <p className={styles.autoSuggestSelectOptionSecondary}>
              {d.customParticipantID}
            </p>
          </div>
        )}
        filterSuggestion={(inputValue, suggestions) => {
          return suggestions.filter(patient =>
            doesValueMatchPersonData(patient, getMRNFromTag(inputValue)),
          );
        }}
        defaultValue={defaultValue}
        maxTags={1}
        renderTag={props => {
          return renderPatientTag(props, tokenPrefix, tokenSuffix);
        }}
        onRemoveTag={inputValue => {
          onRemoveTag('patients', inputValue);
        }}
      />
    </div>
  );
};
export default PatientSearchField;



// WEBPACK FOOTER //
// ./src/views/components/Search/PatientSearchField.jsx